/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Forgotten_At_LaterInputs */

const en_us2_workout_live_forgotten_at_later = /** @type {(inputs: Workout_Live_Forgotten_At_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Half an hour later`)
};

const pt_br2_workout_live_forgotten_at_later = /** @type {(inputs: Workout_Live_Forgotten_At_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meia hora depois`)
};

const es_419_workout_live_forgotten_at_later = /** @type {(inputs: Workout_Live_Forgotten_At_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media hora después`)
};

const pt_pt2_workout_live_forgotten_at_later = /** @type {(inputs: Workout_Live_Forgotten_At_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meia hora depois`)
};

const fr_fr2_workout_live_forgotten_at_later = /** @type {(inputs: Workout_Live_Forgotten_At_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une demi-heure après`)
};

const de_de2_workout_live_forgotten_at_later = /** @type {(inputs: Workout_Live_Forgotten_At_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine halbe Stunde später`)
};

const it_it2_workout_live_forgotten_at_later = /** @type {(inputs: Workout_Live_Forgotten_At_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mezz'ora dopo`)
};

/**
* | output |
* | --- |
* | "Half an hour later" |
*
* @param {Workout_Live_Forgotten_At_LaterInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_forgotten_at_later = /** @type {((inputs?: Workout_Live_Forgotten_At_LaterInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Forgotten_At_LaterInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_forgotten_at_later(inputs)
	if (locale === "es-419") return es_419_workout_live_forgotten_at_later(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_forgotten_at_later(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_forgotten_at_later(inputs)
	if (locale === "de-DE") return de_de2_workout_live_forgotten_at_later(inputs)
	if (locale === "it-IT") return it_it2_workout_live_forgotten_at_later(inputs)
	return en_us2_workout_live_forgotten_at_later(inputs)
});
export { workout_live_forgotten_at_later as "workout-live.forgotten_at_later" }